<template>
  <div id="header" :class="template">
    <router-link class="logo" to="/">
      <div class="scene">
        <div class="cube is-backface-hidden is-spinning">
          <div class="cube__face cube__face--front"></div>
          <div class="cube__face cube__face--back"></div>
          <div class="cube__face cube__face--right"></div>
          <div class="cube__face cube__face--left"></div>
          <div class="cube__face cube__face--top"></div>
          <div class="cube__face cube__face--bottom"></div>
        </div>
      </div>
      SekaiSoft
    </router-link>
    <span style="position: absolute; left: 40%; visibility: hidden">REAL RECOGNISE REAL</span>

    <div class="toggleWrapper">
      <input type="checkbox" ref="chkTemplate" class="dn" id="dn" @click="selectTemplate" :checked="template === 'white' ? false : true" />
      <label for="dn" class="toggle">
            <span class="toggle__handler">
              <span class="crater crater--1"></span>
              <span class="crater crater--2"></span>
              <span class="crater crater--3"></span>
            </span>
        <span class="star star--1"></span>
        <span class="star star--2"></span>
        <span class="star star--3"></span>
        <span class="star star--4"></span>
        <span class="star star--5"></span>
        <span class="star star--6"></span>
      </label>
    </div>

    <ul>
      <li v-for="item in menu" @click="changeMenu(item)" v-bind:class="itemSelected == item.value ? 'active' : ''">
        <router-link class="navbar-brand" :to="item.ruta">{{item.value}}</router-link>
        <div></div>
      </li>
    </ul>
  </div>
</template>

<script>
    import {mapActions, mapMutations, mapState} from 'vuex'

    export default {
        name: "Header",

        computed: mapState([
            'itemSelected',
            'template',
        ]),

        updated: function() {

            if (this.template === 'white'){
                window.document.body.style.background = 'var(--white)'
                window.document.children[0].style.background = 'var(--white)'
            } else {
                window.document.body.style.background = 'var(--color)'
                window.document.children[0].style.background = 'var(--color)'
            }

        },

        methods: {
            ...mapMutations([
                'select_menu',
                'SET_TEMPLATE',
            ]),
            changeMenu: function (item) {
                this.select_menu(item.value);
            },
            selectTemplate: function () {
               localStorage.setItem("template", this.$refs.chkTemplate.checked ? 'black' : 'white');
               this.SET_TEMPLATE(this.$refs.chkTemplate.checked ? 'black' : 'white');
            }
        },

        data: function () {
            return {
                menu: [
                    {logo: '', value: 'PC / Intel', ruta: 'Intel'},
                    {logo: '', value: 'PC / Ryzen', ruta: 'Ryzen'}],
            }
        }
    }
</script>

<style scoped lang="scss">
  @import "../style/base";

  #header {
    padding: 0 20px;
    height: 65px;
    background: var(--color);
    display: flex;
    align-items: center;
    box-shadow: 1px 1px 12px -3px #888888;
    position: sticky;
    top: 0;
    font-family: Montserrat;
    z-index: 99;

    & .logo {
      color: #ff3464;
      font-size: 22px;
      transition: .4s all ease-in-out;
      display: flex;
      align-items: center;

      &:HOVER {
        color: #FF0000;
        transition: .6s all ease-in-out;
      }
    }

    & a {
      color: #444444;
    }

    & ul {
      width: 100%;
      list-style: none;
      display: flex;
      justify-content: flex-end;
      margin: 0;
      padding-inline-start: 0;

      & li {

        & a {
          color: #f3f3f3;
          margin: 0;
          padding: 2px 14px;

        }

        & div {
          width: 0;
          height: 1px;
          height: 1px;
          transition: 0.4s all ease-in-out;
          margin: 0 auto;
        }

        &:HOVER {
          & div {
            width: 25%;
            height: 1px;
            background: #FFFFFF;
            opacity: 0.7;
            transition: 0.6s all ease-in-out;
            align-self: center;
          }
        }

        &.active {
          & div {
            width: 90%;
            height: 1px;
            background: red;
            transition: 0.6s all ease-in-out;
            opacity: 1;
          }
        }
      }
    }

    &.white {
      background: var(--white);
      & .logo {
        color: #ff3464;

        &:HOVER {
          color: #FF0000;
        }
      }

      & ul {
        & li {
          & a {
            color: #888888;
          }
          &:HOVER {
            & div {
              opacity: 0.5;
              background: #FF0000;
            }
          }
          &.active {
            & div {
              background: #FF0000;
            }
          }
        }
      }

    }

    .scene {
      width: 20px;
      height: 20px;
      perspective: 40px;
      margin-right: 10px;
    }

    .cube {
      width: 100%;
      height: 100%;
      position: relative;
      transform-style: preserve-3d;
      transform: translateZ(-10px);
    }

    .cube.is-spinning {
      animation: spinCube 3s infinite ease-in-out;
    }

    .cube__face {
      position: absolute;
      width: 100%;
      height: 100%;
      border: 1px solid black;
      font-weight: bold;
      color: white;
      text-align: center;
    }

    .cube__face--front  { background: hsla(58, 100%, 60%, 0.9); }
    .cube__face--right  { background: hsla(134, 100%, 63%, 0.9); }
    .cube__face--back   { background: hsla(238, 100%, 50%, 0.9); }
    .cube__face--left   { background: hsla(199, 100%, 72%, 0.9); }
    .cube__face--top    { background: hsla(0, 0%, 100%, 0.9); }
    .cube__face--bottom { background: hsla(346, 100%, 62%, 0.7); }

    .cube__face--front  { transform: rotateY(  0deg) translateZ(10px); }
    .cube__face--right  { transform: rotateY( 90deg) translateZ(10px); }
    .cube__face--back   { transform: rotateY(180deg) translateZ(10px); }
    .cube__face--left   { transform: rotateY(-90deg) translateZ(10px); }
    .cube__face--top    { transform: rotateX( 90deg) translateZ(10px); }
    .cube__face--bottom { transform: rotateX(-90deg) translateZ(10px); }

    .cube.is-backface-hidden .cube__face {
      backface-visibility: hidden;
    }


    @keyframes spinCube {
      0% { transform: translateZ(-10px) rotateX(  0deg) rotateY(  0deg); }
      100% { transform: translateZ(-10px) rotateX(360deg) rotateY(360deg); }
    }

  }
</style>
